var _defs, _rect, _g, _path, _path2, _g2, _g3, _path3, _path4, _path5, _path6, _g4, _g5, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g6, _g7, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHajIlustrations2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 4000,
    height: 3000,
    viewBox: "0 0 4000 3000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 663 396 L 3403 396 L 3403 2574 L 663 2574 Z M 663 396 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-1"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 663.109375 2573.691406 C 663.109375 2573.691406 919.1875 2280.949219 774.140625 1903.480469 C 680.703125 1660.300781 747.875 1340.128906 998.277344 1232.589844 C 1376.601562 1070.109375 1268.390625 911.539062 1366.941406 650.128906 C 1479.058594 352.71875 1948.691406 328.640625 2200.910156 515.5 C 2363.621094 636.039062 2359.070312 794.320312 2485.851562 832.269531 C 2622.949219 873.300781 2853.960938 742.019531 3111.21875 915.539062 C 3467.371094 1155.761719 3109.449219 1686.769531 3293.398438 1986.050781 C 3570.75 2437.300781 3233.441406 2573.691406 3233.441406 2573.691406 L 663.105469 2573.691406 L 663.109375 2573.691406 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-pattern-0",
    gradientUnits: "userSpaceOnUse",
    x1: -0.26837,
    y1: 0,
    x2: 2.19415,
    y2: 0,
    gradientTransform: "matrix(0, 911.688, 911.688, 0, 2032.97, 573.31)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(50.587463%, 84.312439%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "rgb(50.587463%, 84.312439%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "rgb(50.587463%, 84.312439%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "rgb(50.601196%, 84.317017%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "rgb(50.898743%, 84.411621%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "rgb(51.18103%, 84.503174%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121094,
    stopColor: "rgb(51.463318%, 84.593201%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "rgb(51.747131%, 84.684753%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128906,
    stopColor: "rgb(52.029419%, 84.77478%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "rgb(52.313232%, 84.864807%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "rgb(52.59552%, 84.954834%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "rgb(52.879333%, 85.046387%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144531,
    stopColor: "rgb(53.161621%, 85.136414%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "rgb(53.445435%, 85.227966%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "rgb(53.727722%, 85.317993%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "rgb(54.011536%, 85.40802%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "rgb(54.293823%, 85.498047%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164063,
    stopColor: "rgb(54.576111%, 85.5896%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "rgb(54.858398%, 85.679626%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "rgb(55.142212%, 85.771179%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175781,
    stopColor: "rgb(55.4245%, 85.861206%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "rgb(55.708313%, 85.951233%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "rgb(55.990601%, 86.04126%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "rgb(56.274414%, 86.132812%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "rgb(56.556702%, 86.222839%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195313,
    stopColor: "rgb(56.840515%, 86.314392%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "rgb(57.122803%, 86.404419%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "rgb(57.406616%, 86.494446%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "rgb(57.688904%, 86.584473%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "rgb(57.971191%, 86.676025%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "rgb(58.253479%, 86.766052%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "rgb(58.537292%, 86.857605%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "rgb(58.81958%, 86.947632%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "rgb(59.103394%, 87.037659%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "rgb(59.385681%, 87.127686%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "rgb(59.669495%, 87.219238%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "rgb(59.951782%, 87.309265%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "rgb(60.235596%, 87.400818%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "rgb(60.517883%, 87.490845%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "rgb(60.801697%, 87.580872%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "rgb(61.083984%, 87.670898%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257813,
    stopColor: "rgb(61.366272%, 87.762451%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "rgb(61.64856%, 87.852478%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "rgb(61.932373%, 87.944031%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "rgb(62.214661%, 88.034058%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "rgb(62.498474%, 88.124084%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "rgb(62.780762%, 88.214111%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "rgb(63.064575%, 88.305664%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "rgb(63.346863%, 88.395691%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "rgb(63.630676%, 88.487244%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "rgb(63.912964%, 88.577271%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "rgb(64.195251%, 88.667297%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "rgb(64.477539%, 88.757324%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "rgb(64.761353%, 88.848877%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "rgb(65.04364%, 88.938904%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "rgb(65.327454%, 89.030457%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "rgb(65.609741%, 89.120483%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "rgb(65.893555%, 89.21051%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "rgb(66.175842%, 89.300537%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "rgb(66.459656%, 89.39209%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "rgb(66.741943%, 89.482117%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "rgb(67.025757%, 89.573669%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "rgb(67.308044%, 89.663696%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "rgb(67.590332%, 89.753723%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "rgb(67.87262%, 89.84375%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "rgb(68.156433%, 89.935303%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "rgb(68.438721%, 90.02533%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "rgb(68.722534%, 90.116882%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "rgb(69.004822%, 90.206909%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "rgb(69.288635%, 90.296936%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "rgb(69.570923%, 90.386963%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "rgb(69.854736%, 90.478516%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "rgb(70.137024%, 90.568542%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "rgb(70.420837%, 90.660095%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "rgb(70.703125%, 90.750122%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "rgb(70.985413%, 90.840149%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "rgb(71.2677%, 90.930176%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "rgb(71.551514%, 91.021729%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "rgb(71.833801%, 91.111755%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "rgb(72.117615%, 91.203308%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "rgb(72.399902%, 91.293335%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "rgb(72.683716%, 91.383362%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "rgb(72.966003%, 91.473389%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "rgb(73.249817%, 91.564941%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "rgb(73.532104%, 91.654968%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "rgb(73.815918%, 91.746521%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "rgb(74.098206%, 91.836548%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "rgb(74.380493%, 91.926575%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "rgb(74.662781%, 92.016602%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "rgb(74.946594%, 92.108154%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "rgb(75.228882%, 92.198181%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "rgb(75.512695%, 92.289734%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "rgb(75.794983%, 92.379761%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "rgb(76.078796%, 92.469788%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "rgb(76.361084%, 92.559814%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "rgb(76.644897%, 92.651367%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "rgb(76.927185%, 92.741394%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "rgb(77.210999%, 92.832947%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "rgb(77.493286%, 92.922974%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "rgb(77.775574%, 93.013%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "rgb(78.057861%, 93.103027%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "rgb(78.341675%, 93.19458%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "rgb(78.623962%, 93.284607%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "rgb(78.907776%, 93.37616%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "rgb(79.190063%, 93.466187%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "rgb(79.473877%, 93.556213%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "rgb(79.736328%, 93.640137%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "rgb(79.998779%, 93.72406%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "rgb(79.998779%, 93.72406%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "rgb(79.998779%, 93.72406%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "rgb(79.998779%, 93.72406%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "rgb(79.998779%, 93.72406%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(79.998779%, 93.72406%, 100%)",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-2"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 1336 396 L 3003 396 L 3003 1196 L 1336 1196 Z M 1336 396 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-3"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 1812.070312 396.308594 L 1816.078125 396.308594 L 1817.53125 396.320312 L 1817.921875 396.320312 L 1819.398438 396.328125 L 1819.738281 396.328125 L 1821.269531 396.351562 L 1821.550781 396.351562 L 1823.148438 396.371094 L 1823.320312 396.371094 L 1825.03125 396.398438 C 1819.640625 440.910156 1823.28125 492.601562 1853.421875 535.320312 C 1896.589844 596.699219 1958.789062 540.828125 2068.101562 644.660156 C 2156.199219 728.339844 2211.21875 671.820312 2298.25 613.179688 C 2300.320312 615.96875 2302.359375 618.75 2304.351562 621.539062 L 2304.789062 622.148438 L 2305.109375 622.601562 L 2305.511719 623.148438 L 2305.890625 623.691406 L 2306.328125 624.308594 L 2306.660156 624.78125 L 2307 625.269531 L 2307.53125 626.011719 L 2307.679688 626.230469 L 2308.128906 626.871094 L 2308.679688 627.648438 L 2308.898438 627.96875 L 2309.328125 628.578125 L 2309.820312 629.300781 L 2310.019531 629.589844 L 2310.511719 630.289062 L 2311 631 L 2311.140625 631.199219 C 2312.101562 632.589844 2313.039062 633.980469 2313.988281 635.371094 L 2314.039062 635.449219 L 2314.578125 636.25 L 2315.140625 637.078125 L 2315.160156 637.109375 C 2320.488281 645.039062 2325.539062 652.921875 2330.398438 660.710938 L 2330.429688 660.761719 L 2331.398438 662.320312 L 2331.5 662.480469 L 2332.410156 663.960938 L 2332.519531 664.140625 L 2333.441406 665.621094 L 2333.53125 665.78125 L 2334.519531 667.390625 C 2286.609375 703.519531 2271.269531 754.5 2183.910156 737.039062 C 2088.289062 717.929688 2047.398438 636.449219 1894.480469 633.859375 C 1732.109375 631.121094 1706.351562 502.230469 1710.378906 404.128906 L 1711.46875 403.960938 L 1712.210938 403.839844 L 1713.191406 403.699219 L 1714.050781 403.570312 L 1714.980469 403.429688 L 1715.878906 403.300781 L 1716.78125 403.160156 L 1717.71875 403.03125 L 1718.601562 402.910156 L 1719.570312 402.769531 L 1720.421875 402.648438 L 1721.421875 402.511719 L 1722.25 402.398438 L 1723.289062 402.261719 L 1724.078125 402.148438 L 1725.160156 402.011719 L 1725.910156 401.910156 L 1727.058594 401.761719 L 1727.75 401.671875 L 1729.011719 401.511719 L 1729.578125 401.441406 L 1731.421875 401.210938 L 1733.300781 400.988281 L 1735.191406 400.761719 L 1735.339844 400.75 L 1737.050781 400.550781 L 1737.449219 400.511719 L 1738.910156 400.351562 L 1739.410156 400.289062 L 1740.78125 400.140625 L 1741.320312 400.078125 L 1742.648438 399.949219 L 1743.210938 399.890625 L 1744.53125 399.75 L 1745.089844 399.691406 L 1746.410156 399.558594 L 1746.96875 399.511719 L 1748.308594 399.378906 L 1748.839844 399.328125 L 1750.230469 399.199219 L 1750.710938 399.160156 L 1752.199219 399.019531 L 1752.578125 398.988281 L 1754.25 398.839844 L 1754.441406 398.820312 C 1756.980469 398.601562 1759.53125 398.398438 1762.078125 398.210938 L 1762.328125 398.191406 L 1763.949219 398.070312 L 1764.359375 398.039062 L 1765.828125 397.941406 L 1766.320312 397.910156 L 1767.710938 397.808594 L 1768.238281 397.78125 L 1769.601562 397.691406 L 1770.148438 397.648438 L 1771.488281 397.570312 L 1772.050781 397.539062 L 1773.398438 397.460938 L 1773.949219 397.429688 L 1775.320312 397.351562 L 1775.839844 397.320312 L 1777.269531 397.25 L 1777.730469 397.21875 L 1779.289062 397.140625 L 1779.609375 397.128906 L 1781.5 397.039062 C 1782.148438 397.011719 1782.800781 396.980469 1783.449219 396.949219 L 1785.339844 396.871094 L 1785.730469 396.859375 L 1787.210938 396.800781 L 1787.820312 396.78125 L 1789.089844 396.730469 L 1789.800781 396.710938 L 1790.960938 396.671875 L 1791.738281 396.640625 L 1792.828125 396.609375 L 1793.660156 396.589844 L 1794.699219 396.558594 L 1795.558594 396.53125 L 1796.570312 396.511719 L 1797.460938 396.488281 L 1798.429688 396.46875 L 1799.359375 396.449219 L 1800.28125 396.429688 L 1801.261719 396.410156 L 1802.121094 396.398438 L 1803.148438 396.378906 L 1803.898438 396.371094 L 1805.039062 396.359375 L 1805.511719 396.351562 C 1807.691406 396.328125 1809.878906 396.308594 1812.070312 396.308594 Z M 1570.800781 444.191406 C 1554.03125 569.378906 1545.660156 729.410156 1616.671875 736.269531 C 1828.121094 756.671875 1937.238281 866.039062 1957.441406 1029.28125 C 1972.761719 1153.101562 2138.351562 1087.859375 2216.699219 969.96875 C 2281.480469 872.5 2388.101562 856.371094 2493.191406 834.28125 C 2493.441406 834.351562 2493.691406 834.410156 2493.941406 834.46875 L 2493.988281 834.480469 L 2494.128906 834.519531 L 2494.570312 834.621094 L 2494.738281 834.660156 L 2494.808594 834.679688 L 2494.921875 834.710938 L 2495.269531 834.789062 L 2495.570312 834.859375 L 2495.640625 834.878906 L 2495.699219 834.890625 C 2551.761719 848.039062 2622.308594 835.898438 2703.148438 828.148438 L 2703.898438 828.078125 L 2705.160156 827.960938 L 2706.191406 827.859375 L 2707.289062 827.761719 L 2708.570312 827.640625 L 2709.460938 827.550781 L 2711.460938 827.371094 L 2711.660156 827.351562 L 2713.988281 827.140625 L 2714.261719 827.121094 L 2716.320312 826.941406 L 2716.730469 826.898438 L 2718.710938 826.730469 L 2719.058594 826.699219 L 2721.269531 826.511719 L 2721.359375 826.5 C 2801.308594 819.769531 2890.640625 819.269531 2985.519531 852.121094 L 2985.691406 852.191406 L 2986.859375 852.589844 L 2987.191406 852.710938 L 2988.230469 853.070312 L 2988.601562 853.199219 L 2989.648438 853.578125 L 2989.980469 853.691406 L 2991.308594 854.171875 L 2991.738281 854.328125 L 2992.621094 854.648438 L 2993.289062 854.890625 L 2993.929688 855.121094 L 2994.679688 855.398438 L 2995.210938 855.589844 L 2996.039062 855.898438 L 2996.429688 856.039062 C 2997.960938 856.621094 2999.488281 857.191406 3001.019531 857.78125 L 3001.03125 857.78125 L 3002.25 858.25 C 2723.839844 1007.511719 2391.679688 799.109375 2266.78125 1029.28125 C 2184.480469 1180.949219 1944.359375 1272.128906 1887.46875 1109.089844 C 1801.25 861.988281 1645.941406 921.46875 1488.679688 847.558594 C 1428.378906 819.210938 1377.488281 785.191406 1336.269531 752.171875 C 1336.621094 750.671875 1336.980469 749.160156 1337.339844 747.640625 L 1337.390625 747.441406 L 1337.679688 746.210938 L 1337.820312 745.609375 L 1338.019531 744.78125 L 1338.199219 744.039062 L 1338.371094 743.351562 L 1338.570312 742.53125 L 1338.71875 741.921875 L 1338.929688 741.050781 L 1339.070312 740.5 L 1339.300781 739.570312 L 1339.421875 739.089844 L 1339.671875 738.101562 L 1339.761719 737.699219 L 1340.03125 736.628906 L 1340.101562 736.378906 C 1340.78125 733.679688 1341.46875 730.96875 1342.179688 728.25 L 1342.230469 728.078125 L 1342.550781 726.859375 L 1342.609375 726.628906 L 1342.921875 725.441406 L 1342.988281 725.171875 L 1343.308594 723.988281 L 1343.378906 723.730469 L 1343.699219 722.53125 L 1343.761719 722.308594 L 1344.101562 721.058594 L 1344.128906 720.949219 C 1344.878906 718.179688 1345.640625 715.410156 1346.429688 712.621094 L 1346.5 712.390625 L 1346.820312 711.230469 L 1346.921875 710.898438 L 1347.238281 709.789062 L 1347.351562 709.398438 L 1347.660156 708.320312 L 1347.78125 707.910156 L 1348.089844 706.828125 L 1348.210938 706.421875 L 1348.519531 705.339844 L 1348.640625 704.949219 L 1348.960938 703.839844 L 1349.050781 703.539062 C 1349.570312 701.789062 1350.089844 700.03125 1350.628906 698.269531 L 1350.730469 697.929688 L 1351.039062 696.910156 L 1351.199219 696.390625 L 1351.480469 695.449219 L 1351.671875 694.859375 L 1351.949219 693.949219 L 1352.140625 693.320312 L 1352.421875 692.429688 L 1352.621094 691.78125 L 1352.890625 690.910156 L 1353.101562 690.238281 L 1353.371094 689.378906 L 1353.589844 688.691406 L 1353.859375 687.839844 L 1354.078125 687.140625 L 1354.351562 686.300781 L 1354.589844 685.558594 L 1354.851562 684.75 L 1355.328125 683.269531 L 1355.570312 682.539062 L 1355.839844 681.710938 L 1356.078125 680.960938 L 1356.351562 680.140625 L 1356.601562 679.398438 L 1356.871094 678.578125 L 1357.121094 677.828125 L 1357.390625 677.011719 L 1357.640625 676.261719 L 1357.921875 675.429688 L 1358.171875 674.699219 L 1358.449219 673.851562 L 1358.699219 673.121094 L 1359 672.25 L 1359.238281 671.550781 L 1359.550781 670.628906 L 1359.78125 669.980469 L 1360.140625 668.929688 L 1360.320312 668.398438 L 1360.871094 666.828125 L 1360.988281 666.5 L 1361.429688 665.238281 L 1361.640625 664.660156 L 1361.988281 663.648438 L 1362.21875 663 L 1362.558594 662.058594 L 1362.800781 661.378906 L 1363.128906 660.460938 L 1363.378906 659.769531 L 1363.710938 658.859375 L 1363.96875 658.171875 L 1364.300781 657.25 L 1364.550781 656.558594 L 1364.890625 655.628906 L 1365.140625 654.960938 L 1365.5 653.980469 L 1365.738281 653.351562 L 1366.140625 652.269531 L 1366.339844 651.738281 L 1366.941406 650.128906 L 1367.328125 649.109375 L 1367.449219 648.800781 L 1367.730469 648.058594 L 1367.859375 647.730469 L 1368.191406 646.878906 L 1368.25 646.699219 L 1368.648438 645.691406 L 1368.761719 645.410156 L 1369.058594 644.660156 L 1369.191406 644.320312 L 1369.5 643.550781 L 1369.601562 643.300781 L 1370.011719 642.289062 L 1370.101562 642.070312 L 1370.421875 641.269531 L 1370.550781 640.949219 L 1370.859375 640.210938 L 1370.980469 639.921875 L 1371.390625 638.921875 L 1371.441406 638.800781 L 1371.808594 637.910156 L 1371.949219 637.601562 L 1372.25 636.878906 L 1372.378906 636.558594 L 1372.769531 635.671875 L 1372.808594 635.558594 L 1373.238281 634.570312 L 1373.371094 634.28125 L 1373.679688 633.558594 L 1373.820312 633.238281 L 1374.160156 632.460938 L 1374.261719 632.238281 L 1374.691406 631.261719 L 1374.808594 631 L 1375.140625 630.261719 L 1375.289062 629.929688 L 1375.609375 629.210938 L 1375.738281 628.941406 L 1376.179688 627.96875 L 1376.269531 627.769531 L 1376.628906 626.980469 L 1376.78125 626.660156 L 1377.109375 625.96875 L 1377.25 625.660156 L 1377.699219 624.699219 L 1377.730469 624.628906 L 1378.160156 623.730469 L 1378.308594 623.410156 L 1378.628906 622.738281 L 1378.789062 622.410156 L 1379.160156 621.628906 L 1379.261719 621.441406 L 1379.71875 620.488281 L 1379.859375 620.199219 L 1380.191406 619.519531 L 1380.359375 619.179688 L 1380.699219 618.488281 L 1380.839844 618.21875 L 1381.300781 617.28125 L 1381.441406 617.019531 L 1381.78125 616.328125 L 1381.960938 615.980469 L 1382.289062 615.328125 L 1382.449219 615.019531 L 1382.921875 614.101562 L 1383.03125 613.890625 L 1383.410156 613.148438 L 1383.589844 612.800781 L 1383.910156 612.191406 L 1384.089844 611.839844 L 1384.488281 611.089844 L 1384.578125 610.898438 L 1384.601562 610.871094 L 1385.058594 610 L 1385.25 609.648438 L 1385.570312 609.058594 L 1385.761719 608.691406 L 1386.109375 608.050781 L 1386.269531 607.75 L 1386.75 606.871094 L 1386.929688 606.53125 L 1387.25 605.941406 L 1387.460938 605.558594 L 1387.78125 604.980469 L 1387.980469 604.628906 L 1388.460938 603.761719 L 1388.640625 603.441406 L 1388.96875 602.851562 L 1389.199219 602.449219 L 1389.5 601.921875 L 1389.71875 601.53125 L 1390.109375 600.851562 L 1390.21875 600.660156 L 1390.371094 600.390625 L 1390.71875 599.78125 L 1390.960938 599.371094 L 1391.25 598.871094 L 1391.488281 598.449219 L 1391.808594 597.910156 L 1392.011719 597.558594 L 1392.089844 597.421875 L 1392.5 596.730469 L 1392.75 596.308594 L 1393.03125 595.828125 L 1393.289062 595.390625 L 1393.570312 594.921875 L 1393.828125 594.5 L 1394.308594 593.699219 L 1394.570312 593.261719 L 1394.839844 592.820312 L 1395.128906 592.359375 L 1395.378906 591.929688 L 1395.671875 591.46875 L 1395.960938 591 L 1396.160156 590.671875 L 1396.441406 590.230469 L 1396.691406 589.828125 L 1396.988281 589.339844 L 1397.230469 588.960938 L 1397.539062 588.46875 L 1397.769531 588.109375 L 1398.050781 587.648438 L 1398.351562 587.191406 L 1398.558594 586.859375 L 1398.890625 586.339844 L 1399.101562 586.011719 L 1399.441406 585.480469 L 1399.640625 585.171875 L 1399.96875 584.660156 L 1400.449219 583.929688 L 1400.460938 583.910156 L 1400.820312 583.359375 L 1401.011719 583.070312 L 1401.371094 582.519531 L 1401.550781 582.25 L 1401.921875 581.691406 C 1402.089844 581.441406 1402.25 581.191406 1402.410156 580.949219 L 1402.800781 580.371094 L 1402.949219 580.160156 L 1403.339844 579.570312 L 1403.488281 579.339844 L 1403.898438 578.738281 L 1403.910156 578.71875 L 1404.398438 578.011719 L 1404.851562 577.339844 L 1404.910156 577.261719 L 1405.339844 576.640625 L 1405.460938 576.460938 L 1405.898438 575.828125 L 1405.941406 575.769531 L 1406.410156 575.089844 C 1406.578125 574.851562 1406.75 574.609375 1406.921875 574.371094 L 1407.378906 573.710938 L 1407.460938 573.601562 L 1407.929688 572.941406 L 1407.96875 572.878906 L 1408.449219 572.199219 C 1408.621094 571.960938 1408.789062 571.71875 1408.960938 571.480469 L 1409.46875 570.78125 L 1409.488281 570.761719 L 1409.988281 570.058594 L 1410.019531 570.03125 C 1449.269531 515.929688 1503.289062 474.960938 1565.820312 446.429688 L 1565.851562 446.410156 L 1566.660156 446.050781 C 1566.929688 445.921875 1567.210938 445.800781 1567.480469 445.671875 L 1568.070312 445.410156 L 1568.398438 445.261719 L 1568.929688 445.019531 L 1569.429688 444.800781 L 1569.859375 444.609375 L 1570.800781 444.191406 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-pattern-1",
    gradientUnits: "userSpaceOnUse",
    x1: -0.0387329,
    y1: 0,
    x2: 1.099626,
    y2: 0,
    gradientTransform: "matrix(0, 769.371, 1280.32, 0, 2169.26, 426.11)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(68.626404%, 90.194702%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "rgb(68.809509%, 90.255737%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "rgb(69.117737%, 90.357971%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "rgb(69.367981%, 90.441895%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "rgb(69.619751%, 90.525818%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "rgb(69.869995%, 90.609741%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "rgb(70.121765%, 90.693665%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "rgb(70.373535%, 90.777588%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "rgb(70.623779%, 90.859985%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "rgb(70.875549%, 90.943909%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "rgb(71.125793%, 91.027832%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "rgb(71.377563%, 91.111755%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "rgb(71.627808%, 91.195679%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "rgb(71.879578%, 91.279602%, 100%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(72.080994%, 91.345215%, 100%)",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-4"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 662 1415 L 3403 1415 L 3403 2574 L 662 2574 Z M 662 1415 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-5"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 3268.269531 1415.75 C 3246.859375 1619.851562 3199.441406 1833.179688 3293.398438 1986.050781 C 3570.75 2437.300781 3233.441406 2573.691406 3233.441406 2573.691406 L 662.761719 2573.691406 L 727.480469 2477.851562 C 791.988281 2361.808594 869.191406 2150.839844 774.140625 1903.480469 C 714.039062 1747.070312 720.386719 1558.808594 799.203125 1415.75 L 3268.269531 1415.75 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-pattern-2",
    gradientUnits: "userSpaceOnUse",
    x1: 0.0192341,
    y1: 0,
    x2: 1.556291,
    y2: 0,
    gradientTransform: "matrix(0, 753.349, 326.064, 0, 2032.8, 1401.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(98.79303%, 88.73291%, 82.728577%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "rgb(98.782349%, 88.642883%, 82.601929%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "rgb(98.764038%, 88.46283%, 82.347107%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "rgb(98.745728%, 88.284302%, 82.092285%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "rgb(98.725891%, 88.105774%, 81.838989%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "rgb(98.707581%, 87.92572%, 81.584167%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "rgb(98.68927%, 87.747192%, 81.330872%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "rgb(98.669434%, 87.568665%, 81.07605%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "rgb(98.651123%, 87.390137%, 80.821228%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "rgb(98.632812%, 87.210083%, 80.567932%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "rgb(98.612976%, 87.031555%, 80.31311%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "rgb(98.594666%, 86.853027%, 80.058289%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "rgb(98.576355%, 86.6745%, 79.804993%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "rgb(98.556519%, 86.494446%, 79.550171%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "rgb(98.538208%, 86.315918%, 79.295349%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117187,
    stopColor: "rgb(98.519897%, 86.13739%, 79.042053%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "rgb(98.500061%, 85.957336%, 78.787231%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132813,
    stopColor: "rgb(98.48175%, 85.778809%, 78.53241%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "rgb(98.461914%, 85.600281%, 78.279114%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "rgb(98.443604%, 85.421753%, 78.024292%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "rgb(98.425293%, 85.241699%, 77.76947%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "rgb(98.405457%, 85.063171%, 77.516174%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "rgb(98.387146%, 84.884644%, 77.261353%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "rgb(98.368835%, 84.70459%, 77.006531%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "rgb(98.348999%, 84.526062%, 76.753235%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "rgb(98.330688%, 84.347534%, 76.498413%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "rgb(98.312378%, 84.169006%, 76.243591%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210937,
    stopColor: "rgb(98.292542%, 83.988953%, 75.990295%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "rgb(98.274231%, 83.810425%, 75.735474%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "rgb(98.25592%, 83.631897%, 75.480652%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "rgb(98.236084%, 83.453369%, 75.227356%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "rgb(98.217773%, 83.273315%, 74.972534%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "rgb(98.199463%, 83.094788%, 74.719238%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "rgb(98.179626%, 82.91626%, 74.464417%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "rgb(98.161316%, 82.736206%, 74.209595%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "rgb(98.143005%, 82.557678%, 73.956299%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "rgb(98.123169%, 82.37915%, 73.701477%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "rgb(98.104858%, 82.200623%, 73.446655%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "rgb(98.086548%, 82.020569%, 73.193359%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "rgb(98.066711%, 81.842041%, 72.938538%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "rgb(98.048401%, 81.663513%, 72.683716%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "rgb(98.03009%, 81.484985%, 72.43042%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "rgb(98.010254%, 81.304932%, 72.175598%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335937,
    stopColor: "rgb(97.991943%, 81.126404%, 71.920776%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "rgb(97.973633%, 80.947876%, 71.66748%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "rgb(97.953796%, 80.767822%, 71.412659%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "rgb(97.935486%, 80.589294%, 71.157837%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367187,
    stopColor: "rgb(97.917175%, 80.410767%, 70.904541%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "rgb(97.897339%, 80.232239%, 70.649719%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "rgb(97.879028%, 80.052185%, 70.394897%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "rgb(97.859192%, 79.873657%, 70.141602%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "rgb(97.840881%, 79.695129%, 69.88678%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "rgb(97.822571%, 79.516602%, 69.631958%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "rgb(97.802734%, 79.336548%, 69.378662%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "rgb(97.784424%, 79.15802%, 69.12384%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "rgb(97.766113%, 78.979492%, 68.869019%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "rgb(97.746277%, 78.799438%, 68.615723%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "rgb(97.727966%, 78.620911%, 68.360901%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "rgb(97.709656%, 78.442383%, 68.107605%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "rgb(97.689819%, 78.263855%, 67.852783%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "rgb(97.671509%, 78.083801%, 67.597961%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "rgb(97.653198%, 77.905273%, 67.344666%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "rgb(97.633362%, 77.726746%, 67.089844%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "rgb(97.615051%, 77.548218%, 66.835022%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "rgb(97.596741%, 77.368164%, 66.581726%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "rgb(97.576904%, 77.189636%, 66.326904%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "rgb(97.558594%, 77.011108%, 66.072083%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "rgb(97.540283%, 76.831055%, 65.818787%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "rgb(97.520447%, 76.652527%, 65.563965%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "rgb(97.502136%, 76.473999%, 65.309143%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "rgb(97.483826%, 76.295471%, 65.055847%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "rgb(97.463989%, 76.115417%, 64.801025%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "rgb(97.445679%, 75.93689%, 64.546204%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570313,
    stopColor: "rgb(97.427368%, 75.758362%, 64.292908%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "rgb(97.407532%, 75.578308%, 64.038086%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "rgb(97.389221%, 75.39978%, 63.783264%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "rgb(97.370911%, 75.221252%, 63.529968%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601563,
    stopColor: "rgb(97.351074%, 75.042725%, 63.275146%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "rgb(97.332764%, 74.862671%, 63.020325%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "rgb(97.312927%, 74.684143%, 62.767029%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "rgb(97.294617%, 74.505615%, 62.512207%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "rgb(97.276306%, 74.327087%, 62.258911%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "rgb(97.259521%, 74.176025%, 62.045288%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "rgb(97.253418%, 74.116516%, 61.959839%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "rgb(97.253418%, 74.116516%, 61.959839%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "rgb(97.253418%, 74.116516%, 61.959839%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(97.253418%, 74.116516%, 61.959839%)",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-6"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 2896.890625 672.878906 L 3134.75 672.878906 L 3134.75 1415.351562 L 2896.890625 1415.351562 Z M 2896.890625 672.878906 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-pattern-3",
    gradientUnits: "userSpaceOnUse",
    x1: -6.66e-16,
    y1: 0,
    x2: 0.92703,
    y2: 0,
    gradientTransform: "matrix(0, 800.913, 111.054, 0, 3015.82, 672.88)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(98.822021%, 89.01825%, 83.135986%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "rgb(98.809814%, 88.899231%, 82.969666%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "rgb(98.786926%, 88.66272%, 82.63855%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "rgb(98.762512%, 88.426208%, 82.307434%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "rgb(98.739624%, 88.189697%, 81.976318%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "rgb(98.71521%, 87.953186%, 81.645203%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "rgb(98.692322%, 87.716675%, 81.314087%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "rgb(98.667908%, 87.480164%, 80.981445%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "rgb(98.64502%, 87.243652%, 80.65033%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "rgb(98.620605%, 87.005615%, 80.319214%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "rgb(98.597717%, 86.769104%, 79.988098%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "rgb(98.573303%, 86.532593%, 79.656982%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "rgb(98.550415%, 86.296082%, 79.325867%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "rgb(98.526001%, 86.05957%, 78.993225%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "rgb(98.503113%, 85.823059%, 78.662109%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "rgb(98.478699%, 85.586548%, 78.330994%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "rgb(98.455811%, 85.350037%, 77.999878%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "rgb(98.4375%, 85.173035%, 77.75116%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "rgb(98.425293%, 85.049438%, 77.578735%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "rgb(98.410034%, 84.910583%, 77.378845%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "rgb(98.39325%, 84.75647%, 77.159119%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "rgb(98.377991%, 84.603882%, 76.940918%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "rgb(98.361206%, 84.451294%, 76.722717%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "rgb(98.344421%, 84.298706%, 76.504517%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "rgb(98.327637%, 84.144592%, 76.286316%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "rgb(98.312378%, 83.992004%, 76.068115%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "rgb(98.295593%, 83.839417%, 75.848389%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "rgb(98.278809%, 83.686829%, 75.630188%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "rgb(98.262024%, 83.534241%, 75.411987%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "rgb(98.246765%, 83.380127%, 75.193787%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "rgb(98.22998%, 83.227539%, 74.975586%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "rgb(98.213196%, 83.074951%, 74.757385%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "rgb(98.196411%, 82.922363%, 74.537659%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "rgb(98.181152%, 82.76825%, 74.319458%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "rgb(98.164368%, 82.615662%, 74.101257%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "rgb(98.147583%, 82.463074%, 73.883057%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "rgb(98.130798%, 82.310486%, 73.664856%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "rgb(98.11554%, 82.156372%, 73.445129%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "rgb(98.098755%, 82.003784%, 73.226929%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "rgb(98.08197%, 81.851196%, 73.008728%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "rgb(98.065186%, 81.698608%, 72.790527%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "rgb(98.049927%, 81.546021%, 72.572327%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "rgb(98.033142%, 81.391907%, 72.354126%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "rgb(98.016357%, 81.239319%, 72.134399%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "rgb(98.001099%, 81.086731%, 71.916199%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "rgb(97.984314%, 80.934143%, 71.697998%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "rgb(97.967529%, 80.780029%, 71.479797%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "rgb(97.950745%, 80.627441%, 71.261597%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "rgb(97.935486%, 80.474854%, 71.04187%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "rgb(97.918701%, 80.322266%, 70.823669%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "rgb(97.901917%, 80.169678%, 70.605469%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "rgb(97.885132%, 80.015564%, 70.387268%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "rgb(97.869873%, 79.862976%, 70.169067%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "rgb(97.853088%, 79.710388%, 69.950867%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "rgb(97.836304%, 79.5578%, 69.73114%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "rgb(97.819519%, 79.403687%, 69.512939%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "rgb(97.80426%, 79.251099%, 69.294739%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "rgb(97.787476%, 79.098511%, 69.076538%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "rgb(97.770691%, 78.945923%, 68.858337%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "rgb(97.753906%, 78.793335%, 68.638611%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "rgb(97.738647%, 78.639221%, 68.42041%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "rgb(97.721863%, 78.486633%, 68.202209%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "rgb(97.705078%, 78.334045%, 67.984009%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "rgb(97.688293%, 78.181458%, 67.765808%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "rgb(97.673035%, 78.027344%, 67.547607%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "rgb(97.65625%, 77.874756%, 67.327881%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "rgb(97.639465%, 77.722168%, 67.10968%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "rgb(97.624207%, 77.56958%, 66.891479%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "rgb(97.607422%, 77.416992%, 66.673279%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "rgb(97.590637%, 77.262878%, 66.455078%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "rgb(97.573853%, 77.110291%, 66.236877%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "rgb(97.558594%, 76.957703%, 66.017151%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "rgb(97.541809%, 76.805115%, 65.79895%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "rgb(97.525024%, 76.651001%, 65.58075%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960937,
    stopColor: "rgb(97.50824%, 76.498413%, 65.362549%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "rgb(97.492981%, 76.345825%, 65.144348%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "rgb(97.476196%, 76.193237%, 64.924622%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "rgb(97.459412%, 76.039124%, 64.706421%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "rgb(97.442627%, 75.886536%, 64.48822%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(97.427368%, 75.733948%, 64.27002%)",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-7"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 2936.910156 709.128906 L 3094.730469 709.128906 L 3094.730469 1194.378906 L 2936.910156 1194.378906 Z M 2936.910156 709.128906 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-pattern-4",
    gradientUnits: "userSpaceOnUse",
    x1: -0.00000900764,
    y1: 0,
    x2: 1.000005,
    y2: 0,
    gradientTransform: "matrix(-0.582694, 485.432, 68.3337, 0.0820253, 3016.11, 709.04)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(100%, 94.116211%, 89.802551%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "rgb(99.986267%, 94.00177%, 89.649963%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "rgb(99.960327%, 93.771362%, 89.343262%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "rgb(99.934387%, 93.54248%, 89.03656%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "rgb(99.909973%, 93.312073%, 88.729858%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "rgb(99.884033%, 93.083191%, 88.424683%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "rgb(99.858093%, 92.852783%, 88.117981%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "rgb(99.832153%, 92.622375%, 87.811279%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "rgb(99.807739%, 92.393494%, 87.504578%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "rgb(99.781799%, 92.163086%, 87.197876%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "rgb(99.755859%, 91.934204%, 86.8927%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "rgb(99.729919%, 91.703796%, 86.585999%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "rgb(99.705505%, 91.473389%, 86.279297%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "rgb(99.679565%, 91.244507%, 85.972595%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "rgb(99.653625%, 91.014099%, 85.665894%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "rgb(99.627686%, 90.785217%, 85.360718%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "rgb(99.604797%, 90.589905%, 85.098267%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "rgb(99.569702%, 90.367126%, 84.793091%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "rgb(99.5224%, 90.083313%, 84.403992%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "rgb(99.475098%, 89.801025%, 84.014893%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "rgb(99.427795%, 89.517212%, 83.627319%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "rgb(99.380493%, 89.234924%, 83.23822%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "rgb(99.333191%, 88.952637%, 82.849121%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "rgb(99.287415%, 88.668823%, 82.460022%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "rgb(99.240112%, 88.386536%, 82.070923%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "rgb(99.19281%, 88.104248%, 81.681824%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "rgb(99.145508%, 87.820435%, 81.29425%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "rgb(99.098206%, 87.538147%, 80.905151%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "rgb(99.050903%, 87.255859%, 80.516052%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "rgb(99.003601%, 86.972046%, 80.126953%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "rgb(98.956299%, 86.689758%, 79.737854%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "rgb(98.908997%, 86.407471%, 79.348755%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "rgb(98.86322%, 86.123657%, 78.961182%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "rgb(98.815918%, 85.84137%, 78.572083%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "rgb(98.768616%, 85.559082%, 78.182983%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "rgb(98.721313%, 85.275269%, 77.793884%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "rgb(98.674011%, 84.992981%, 77.404785%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "rgb(98.626709%, 84.710693%, 77.015686%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "rgb(98.579407%, 84.42688%, 76.626587%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "rgb(98.532104%, 84.144592%, 76.239014%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "rgb(98.484802%, 83.862305%, 75.849915%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "rgb(98.439026%, 83.578491%, 75.460815%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "rgb(98.391724%, 83.296204%, 75.071716%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "rgb(98.344421%, 83.013916%, 74.682617%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "rgb(98.297119%, 82.730103%, 74.293518%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "rgb(98.249817%, 82.447815%, 73.905945%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "rgb(98.202515%, 82.165527%, 73.516846%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "rgb(98.155212%, 81.881714%, 73.127747%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "rgb(98.10791%, 81.599426%, 72.738647%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(98.060608%, 81.317139%, 72.349548%)",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-8"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 1752.441406 672.878906 L 1990.300781 672.878906 L 1990.300781 1415.351562 L 1752.441406 1415.351562 Z M 1752.441406 672.878906 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-pattern-5",
    gradientUnits: "userSpaceOnUse",
    x1: -6.66e-16,
    y1: 0,
    x2: 0.92703,
    y2: 0,
    gradientTransform: "matrix(0, 800.913, 111.054, 0, 1871.37, 672.88)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(98.822021%, 89.01825%, 83.135986%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "rgb(98.809814%, 88.899231%, 82.969666%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "rgb(98.786926%, 88.66272%, 82.63855%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "rgb(98.762512%, 88.426208%, 82.307434%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "rgb(98.739624%, 88.189697%, 81.976318%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "rgb(98.71521%, 87.953186%, 81.645203%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "rgb(98.692322%, 87.716675%, 81.314087%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "rgb(98.667908%, 87.480164%, 80.981445%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "rgb(98.64502%, 87.243652%, 80.65033%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "rgb(98.620605%, 87.005615%, 80.319214%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "rgb(98.597717%, 86.769104%, 79.988098%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "rgb(98.573303%, 86.532593%, 79.656982%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "rgb(98.550415%, 86.296082%, 79.325867%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "rgb(98.526001%, 86.05957%, 78.993225%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "rgb(98.503113%, 85.823059%, 78.662109%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "rgb(98.478699%, 85.586548%, 78.330994%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "rgb(98.455811%, 85.350037%, 77.999878%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "rgb(98.4375%, 85.173035%, 77.75116%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "rgb(98.425293%, 85.049438%, 77.578735%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "rgb(98.410034%, 84.910583%, 77.378845%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "rgb(98.39325%, 84.75647%, 77.159119%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "rgb(98.377991%, 84.603882%, 76.940918%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "rgb(98.361206%, 84.451294%, 76.722717%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "rgb(98.344421%, 84.298706%, 76.504517%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "rgb(98.327637%, 84.144592%, 76.286316%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "rgb(98.312378%, 83.992004%, 76.068115%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "rgb(98.295593%, 83.839417%, 75.848389%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "rgb(98.278809%, 83.686829%, 75.630188%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "rgb(98.262024%, 83.534241%, 75.411987%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "rgb(98.246765%, 83.380127%, 75.193787%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "rgb(98.22998%, 83.227539%, 74.975586%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "rgb(98.213196%, 83.074951%, 74.757385%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "rgb(98.196411%, 82.922363%, 74.537659%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "rgb(98.181152%, 82.76825%, 74.319458%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "rgb(98.164368%, 82.615662%, 74.101257%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "rgb(98.147583%, 82.463074%, 73.883057%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "rgb(98.130798%, 82.310486%, 73.664856%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "rgb(98.11554%, 82.156372%, 73.445129%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "rgb(98.098755%, 82.003784%, 73.226929%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "rgb(98.08197%, 81.851196%, 73.008728%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "rgb(98.065186%, 81.698608%, 72.790527%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "rgb(98.049927%, 81.546021%, 72.572327%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "rgb(98.033142%, 81.391907%, 72.354126%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "rgb(98.016357%, 81.239319%, 72.134399%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "rgb(98.001099%, 81.086731%, 71.916199%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "rgb(97.984314%, 80.934143%, 71.697998%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "rgb(97.967529%, 80.780029%, 71.479797%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "rgb(97.950745%, 80.627441%, 71.261597%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "rgb(97.935486%, 80.474854%, 71.04187%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "rgb(97.918701%, 80.322266%, 70.823669%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "rgb(97.901917%, 80.169678%, 70.605469%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "rgb(97.885132%, 80.015564%, 70.387268%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "rgb(97.869873%, 79.862976%, 70.169067%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "rgb(97.853088%, 79.710388%, 69.950867%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "rgb(97.836304%, 79.5578%, 69.73114%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "rgb(97.819519%, 79.403687%, 69.512939%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "rgb(97.80426%, 79.251099%, 69.294739%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "rgb(97.787476%, 79.098511%, 69.076538%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "rgb(97.770691%, 78.945923%, 68.858337%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "rgb(97.753906%, 78.793335%, 68.638611%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "rgb(97.738647%, 78.639221%, 68.42041%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "rgb(97.721863%, 78.486633%, 68.202209%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "rgb(97.705078%, 78.334045%, 67.984009%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "rgb(97.688293%, 78.181458%, 67.765808%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "rgb(97.673035%, 78.027344%, 67.547607%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "rgb(97.65625%, 77.874756%, 67.327881%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "rgb(97.639465%, 77.722168%, 67.10968%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "rgb(97.624207%, 77.56958%, 66.891479%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "rgb(97.607422%, 77.416992%, 66.673279%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "rgb(97.590637%, 77.262878%, 66.455078%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "rgb(97.573853%, 77.110291%, 66.236877%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "rgb(97.558594%, 76.957703%, 66.017151%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "rgb(97.541809%, 76.805115%, 65.79895%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "rgb(97.525024%, 76.651001%, 65.58075%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960937,
    stopColor: "rgb(97.50824%, 76.498413%, 65.362549%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "rgb(97.492981%, 76.345825%, 65.144348%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "rgb(97.476196%, 76.193237%, 64.924622%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "rgb(97.459412%, 76.039124%, 64.706421%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "rgb(97.442627%, 75.886536%, 64.48822%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(97.427368%, 75.733948%, 64.27002%)",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-9"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 1792.460938 709.128906 L 1950.28125 709.128906 L 1950.28125 1194.378906 L 1792.460938 1194.378906 Z M 1792.460938 709.128906 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-pattern-6",
    gradientUnits: "userSpaceOnUse",
    x1: -0.00000900764,
    y1: 0,
    x2: 1.000005,
    y2: 0,
    gradientTransform: "matrix(-0.582694, 485.432, 68.3337, 0.0820253, 1871.66, 709.04)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(100%, 94.116211%, 89.802551%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "rgb(99.986267%, 94.00177%, 89.649963%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "rgb(99.960327%, 93.771362%, 89.343262%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "rgb(99.934387%, 93.54248%, 89.03656%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "rgb(99.909973%, 93.312073%, 88.729858%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "rgb(99.884033%, 93.083191%, 88.424683%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "rgb(99.858093%, 92.852783%, 88.117981%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "rgb(99.832153%, 92.622375%, 87.811279%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "rgb(99.807739%, 92.393494%, 87.504578%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "rgb(99.781799%, 92.163086%, 87.197876%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "rgb(99.755859%, 91.934204%, 86.8927%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "rgb(99.729919%, 91.703796%, 86.585999%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "rgb(99.705505%, 91.473389%, 86.279297%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "rgb(99.679565%, 91.244507%, 85.972595%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "rgb(99.653625%, 91.014099%, 85.665894%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "rgb(99.627686%, 90.785217%, 85.360718%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "rgb(99.604797%, 90.589905%, 85.098267%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "rgb(99.569702%, 90.367126%, 84.793091%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "rgb(99.5224%, 90.083313%, 84.403992%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "rgb(99.475098%, 89.801025%, 84.014893%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "rgb(99.427795%, 89.517212%, 83.627319%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "rgb(99.380493%, 89.234924%, 83.23822%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "rgb(99.333191%, 88.952637%, 82.849121%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "rgb(99.287415%, 88.668823%, 82.460022%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "rgb(99.240112%, 88.386536%, 82.070923%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "rgb(99.19281%, 88.104248%, 81.681824%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "rgb(99.145508%, 87.820435%, 81.29425%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "rgb(99.098206%, 87.538147%, 80.905151%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "rgb(99.050903%, 87.255859%, 80.516052%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "rgb(99.003601%, 86.972046%, 80.126953%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "rgb(98.956299%, 86.689758%, 79.737854%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "rgb(98.908997%, 86.407471%, 79.348755%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "rgb(98.86322%, 86.123657%, 78.961182%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "rgb(98.815918%, 85.84137%, 78.572083%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "rgb(98.768616%, 85.559082%, 78.182983%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "rgb(98.721313%, 85.275269%, 77.793884%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "rgb(98.674011%, 84.992981%, 77.404785%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "rgb(98.626709%, 84.710693%, 77.015686%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "rgb(98.579407%, 84.42688%, 76.626587%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "rgb(98.532104%, 84.144592%, 76.239014%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "rgb(98.484802%, 83.862305%, 75.849915%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "rgb(98.439026%, 83.578491%, 75.460815%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "rgb(98.391724%, 83.296204%, 75.071716%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "rgb(98.344421%, 83.013916%, 74.682617%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "rgb(98.297119%, 82.730103%, 74.293518%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "rgb(98.249817%, 82.447815%, 73.905945%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "rgb(98.202515%, 82.165527%, 73.516846%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "rgb(98.155212%, 81.881714%, 73.127747%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "rgb(98.10791%, 81.599426%, 72.738647%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(98.060608%, 81.317139%, 72.349548%)",
    stopOpacity: 1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -400,
    y: -300,
    width: 4800,
    height: 3600,
    fill: "rgb(100%, 100%, 100%)",
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "url(#linear-pattern-0)",
    d: "M 663.105469 328.640625 L 3570.75 328.640625 L 3570.75 2573.691406 L 663.105469 2573.691406 Z M 663.105469 328.640625 "
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(92.576599%, 96.875%, 100%)",
    fillOpacity: 1,
    d: "M 1306.75 906.398438 C 1410.058594 911.898438 1505.589844 968.710938 1501.378906 1091.460938 C 1551.941406 1082.421875 1605.941406 1111.101562 1586.558594 1184.011719 C 1651.28125 1127.96875 2068.199219 1065.25 2065.160156 1485 L 767.847656 1485 C 807.945312 1374.96875 884.046875 1281.648438 998.28125 1232.589844 C 1234.769531 1131.03125 1281.148438 1030.988281 1306.75 906.398438 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(92.576599%, 96.875%, 100%)",
    fillOpacity: 1,
    d: "M 3268.429688 1414.238281 L 2070.921875 1405.800781 C 2107.871094 1223.449219 2263.570312 1166.980469 2382.171875 1214.960938 C 2399.699219 1123.601562 2575.039062 1115.421875 2621.371094 1188.96875 C 2637.039062 1099.839844 2699.671875 1072.679688 2785.269531 1112.429688 C 2788.789062 961.929688 2946.121094 903.339844 3098.800781 907.390625 C 3102.949219 910.039062 3107.078125 912.75 3111.230469 915.550781 C 3285.03125 1032.78125 3288.78125 1219.25 3268.429688 1414.238281 "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-3)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "url(#linear-pattern-1)",
    d: "M 1336.269531 396.308594 L 3002.25 396.308594 L 3002.25 1272.128906 L 1336.269531 1272.128906 Z M 1336.269531 396.308594 "
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-5)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "url(#linear-pattern-2)",
    d: "M 662.761719 1415.75 L 3570.75 1415.75 L 3570.75 2573.691406 L 662.761719 2573.691406 Z M 662.761719 1415.75 "
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(87.889099%, 60.351562%, 43.138123%)",
    fillOpacity: 1,
    d: "M 3273.410156 1948.109375 C 3279.21875 1961.128906 3285.851562 1973.789062 3293.390625 1986.050781 C 3305.820312 2006.269531 3317.011719 2025.851562 3327.03125 2044.789062 L 811.644531 2044.789062 C 806.960938 2013.398438 799.761719 1981.121094 789.585938 1948.109375 L 3273.421875 1948.109375 L 3273.410156 1948.109375 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(87.889099%, 60.351562%, 43.138123%)",
    fillOpacity: 1,
    d: "M 3268.140625 1416.929688 C 3266.308594 1434.171875 3264.328125 1451.398438 3262.261719 1468.609375 L 3262.019531 1470.601562 L 773.335938 1470.601562 C 780.863281 1451.71875 789.480469 1433.390625 799.203125 1415.75 L 3268.261719 1415.75 L 3268.140625 1416.929688 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(78.514099%, 50.584412%, 34.104919%)",
    fillOpacity: 1,
    d: "M 1004.910156 1640.488281 C 1004.910156 1618.210938 995.550781 1596.839844 978.886719 1581.078125 C 962.226562 1565.328125 939.625 1556.480469 916.0625 1556.480469 C 892.496094 1556.480469 869.898438 1565.328125 853.234375 1581.078125 C 836.574219 1596.839844 827.214844 1618.210938 827.214844 1640.488281 C 827.214844 1726.238281 827.214844 1846.839844 827.214844 1846.839844 L 1004.910156 1846.839844 Z M 1270.238281 1640.488281 C 1270.238281 1618.210938 1260.871094 1596.839844 1244.210938 1581.078125 C 1227.550781 1565.328125 1204.949219 1556.480469 1181.390625 1556.480469 C 1157.820312 1556.480469 1135.21875 1565.328125 1118.558594 1581.078125 C 1101.898438 1596.839844 1092.539062 1618.210938 1092.539062 1640.488281 C 1092.539062 1726.238281 1092.539062 1846.839844 1092.539062 1846.839844 L 1270.238281 1846.839844 Z M 2982.980469 1640.488281 C 2982.980469 1618.210938 2973.609375 1596.839844 2956.949219 1581.078125 C 2940.289062 1565.328125 2917.691406 1556.480469 2894.128906 1556.480469 C 2870.558594 1556.480469 2847.960938 1565.328125 2831.300781 1581.078125 C 2814.640625 1596.839844 2805.28125 1618.210938 2805.28125 1640.488281 C 2805.28125 1726.238281 2805.28125 1846.839844 2805.28125 1846.839844 L 2982.980469 1846.839844 Z M 3244.339844 1846.839844 L 3070.601562 1846.839844 L 3070.601562 1640.488281 C 3070.601562 1618.210938 3079.96875 1596.839844 3096.628906 1581.078125 C 3113.289062 1565.328125 3135.890625 1556.480469 3159.449219 1556.480469 C 3183.019531 1556.480469 3205.621094 1565.328125 3222.28125 1581.078125 C 3232.921875 1591.140625 3240.578125 1603.488281 3244.730469 1616.910156 C 3236.621094 1697.128906 3233.03125 1775.21875 3244.339844 1846.839844 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(78.514099%, 50.584412%, 34.521484%)",
    fillOpacity: 1,
    d: "M 3070.601562 2573.691406 L 3070.601562 2254.03125 C 3070.601562 2231.75 3079.960938 2210.378906 3096.628906 2194.628906 C 3113.289062 2178.871094 3135.890625 2170.019531 3159.449219 2170.019531 C 3183.019531 2170.019531 3205.609375 2178.871094 3222.28125 2194.628906 C 3238.941406 2210.378906 3248.300781 2231.75 3248.300781 2254.03125 L 3248.300781 2566.460938 C 3239.070312 2571.410156 3233.429688 2573.691406 3233.429688 2573.691406 Z M 2805.28125 2573.691406 L 2982.96875 2573.691406 L 2982.96875 2254.03125 C 2982.96875 2231.75 2973.609375 2210.378906 2956.949219 2194.628906 C 2940.289062 2178.871094 2917.691406 2170.019531 2894.128906 2170.019531 C 2870.558594 2170.019531 2847.960938 2178.871094 2831.300781 2194.628906 C 2814.640625 2210.378906 2805.28125 2231.75 2805.28125 2254.03125 Z M 1092.539062 2573.691406 L 1270.230469 2573.691406 L 1270.230469 2254.03125 C 1270.230469 2231.75 1260.871094 2210.378906 1244.210938 2194.628906 C 1227.550781 2178.871094 1204.949219 2170.019531 1181.390625 2170.019531 C 1157.820312 2170.019531 1135.21875 2178.871094 1118.558594 2194.628906 C 1101.898438 2210.378906 1092.539062 2231.75 1092.539062 2254.03125 Z M 827.214844 2573.691406 L 1004.910156 2573.691406 L 1004.910156 2254.03125 C 1004.910156 2231.75 995.546875 2210.378906 978.886719 2194.628906 C 962.222656 2178.871094 939.625 2170.019531 916.0625 2170.019531 L 916.058594 2170.019531 C 892.496094 2170.019531 869.898438 2178.871094 853.234375 2194.628906 C 836.574219 2210.378906 827.214844 2231.75 827.214844 2254.03125 L 827.214844 2573.691406 "
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-6)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "url(#linear-pattern-3)",
    d: "M 2896.890625 672.878906 L 3134.75 672.878906 L 3134.75 1415.351562 L 2896.890625 1415.351562 Z M 2896.890625 672.878906 "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-7)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "url(#linear-pattern-4)",
    d: "M 2936.910156 708.941406 L 3095.3125 709.128906 L 3094.730469 1194.570312 L 2936.328125 1194.378906 Z M 2936.910156 708.941406 "
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(78.90625%, 50.193787%, 34.910583%)",
    fillOpacity: 1,
    d: "M 3070.78125 822.320312 C 3070.78125 807.75 3064.988281 793.769531 3054.679688 783.46875 C 3044.378906 773.160156 3030.398438 767.371094 3015.828125 767.371094 L 3015.820312 767.371094 C 3001.25 767.371094 2987.269531 773.160156 2976.96875 783.46875 C 2966.660156 793.769531 2960.871094 807.75 2960.871094 822.320312 C 2960.871094 865.808594 2960.871094 919.25 2960.871094 919.25 L 3070.78125 919.25 L 3070.78125 822.320312 "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(78.90625%, 50.193787%, 34.910583%)",
    fillOpacity: 1,
    d: "M 3071.261719 1208.730469 C 3071.261719 1194.160156 3065.46875 1180.179688 3055.160156 1169.871094 C 3044.859375 1159.570312 3030.878906 1153.78125 3016.308594 1153.78125 L 3016.300781 1153.78125 C 3001.730469 1153.78125 2987.75 1159.570312 2977.449219 1169.871094 C 2967.140625 1180.179688 2961.351562 1194.148438 2961.351562 1208.730469 C 2961.351562 1252.210938 2961.351562 1305.660156 2961.351562 1305.660156 L 3071.261719 1305.660156 L 3071.261719 1208.730469 "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(87.889099%, 60.351562%, 43.138123%)",
    fillOpacity: 1,
    d: "M 3168.941406 1056.808594 C 3168.941406 1041.429688 3156.449219 1028.949219 3141.078125 1028.949219 L 2890.558594 1028.949219 C 2875.179688 1028.949219 2862.699219 1041.429688 2862.699219 1056.808594 C 2862.699219 1072.191406 2875.179688 1084.671875 2890.558594 1084.671875 L 3141.078125 1084.671875 C 3156.449219 1084.671875 3168.941406 1072.191406 3168.941406 1056.808594 "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(87.889099%, 60.351562%, 43.138123%)",
    fillOpacity: 1,
    d: "M 3168.941406 672.878906 C 3168.941406 658.859375 3157.558594 647.480469 3143.550781 647.480469 L 2888.089844 647.480469 C 2874.078125 647.480469 2862.699219 658.859375 2862.699219 672.878906 C 2862.699219 686.890625 2874.078125 698.269531 2888.089844 698.269531 L 3143.550781 698.269531 C 3157.558594 698.269531 3168.941406 686.890625 3168.941406 672.878906 "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(98.4375%, 84.375%, 75.78125%)",
    fillOpacity: 1,
    d: "M 3015.820312 495.609375 C 2971.859375 577.570312 2871.011719 556.519531 2896.890625 647.480469 L 3134.75 647.480469 C 3165.539062 550.679688 3049.441406 582.28125 3015.820312 495.609375 "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(99.609375%, 89.0625%, 82.421875%)",
    fillOpacity: 1,
    d: "M 3015.820312 495.609375 C 2993.050781 569.578125 2940.820312 594.109375 2969.070312 647.480469 L 3062.570312 647.480469 C 3103.828125 583.859375 3045.808594 593.03125 3015.820312 495.609375 "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(87.889099%, 60.351562%, 43.138123%)",
    fillOpacity: 1,
    d: "M 3012.480469 479.878906 C 2999.679688 478.269531 2988.558594 468.988281 2985.25 455.71875 C 2980.960938 438.480469 2991.460938 420.988281 3008.710938 416.699219 C 3013.371094 415.539062 3018.050781 415.460938 3022.488281 416.300781 C 3021.828125 416.410156 3021.171875 416.550781 3020.5 416.710938 C 3007.179688 420.03125 2999.058594 433.539062 3002.378906 446.859375 C 3005.699219 460.191406 3019.210938 468.308594 3032.53125 464.988281 C 3039.53125 463.238281 3045.089844 458.691406 3048.308594 452.820312 C 3046.390625 465.261719 3037.238281 475.941406 3024.269531 479.171875 C 3022.570312 479.601562 3020.859375 479.878906 3019.171875 480.019531 L 3019.171875 510.300781 L 3012.480469 510.300781 L 3012.480469 479.878906 "
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-8)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "url(#linear-pattern-5)",
    d: "M 1752.441406 672.878906 L 1990.300781 672.878906 L 1990.300781 1415.351562 L 1752.441406 1415.351562 Z M 1752.441406 672.878906 "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-9)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "url(#linear-pattern-6)",
    d: "M 1792.460938 708.941406 L 1950.863281 709.128906 L 1950.28125 1194.570312 L 1791.878906 1194.378906 Z M 1792.460938 708.941406 "
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(78.90625%, 50.193787%, 34.910583%)",
    fillOpacity: 1,
    d: "M 1926.328125 822.320312 C 1926.328125 807.75 1920.539062 793.769531 1910.230469 783.46875 C 1899.929688 773.160156 1885.949219 767.371094 1871.378906 767.371094 C 1871.378906 767.371094 1871.378906 767.371094 1871.371094 767.371094 C 1856.800781 767.371094 1842.820312 773.160156 1832.519531 783.46875 C 1822.210938 793.769531 1816.421875 807.75 1816.421875 822.320312 C 1816.421875 865.808594 1816.421875 919.25 1816.421875 919.25 L 1926.328125 919.25 L 1926.328125 822.320312 "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(78.90625%, 50.193787%, 34.910583%)",
    fillOpacity: 1,
    d: "M 1926.808594 1208.730469 C 1926.808594 1194.160156 1921.019531 1180.179688 1910.710938 1169.871094 C 1900.410156 1159.570312 1886.429688 1153.78125 1871.859375 1153.78125 L 1871.851562 1153.78125 C 1857.28125 1153.78125 1843.300781 1159.570312 1833 1169.871094 C 1822.691406 1180.179688 1816.898438 1194.148438 1816.898438 1208.730469 C 1816.898438 1252.210938 1816.898438 1305.660156 1816.898438 1305.660156 L 1926.808594 1305.660156 L 1926.808594 1208.730469 "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(87.889099%, 60.351562%, 43.138123%)",
    fillOpacity: 1,
    d: "M 2024.488281 1056.808594 C 2024.488281 1041.429688 2012.011719 1028.949219 1996.628906 1028.949219 L 1746.109375 1028.949219 C 1730.730469 1028.949219 1718.25 1041.429688 1718.25 1056.808594 C 1718.25 1072.191406 1730.730469 1084.671875 1746.109375 1084.671875 L 1996.628906 1084.671875 C 2012 1084.671875 2024.488281 1072.191406 2024.488281 1056.808594 "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(87.889099%, 60.351562%, 43.138123%)",
    fillOpacity: 1,
    d: "M 2024.488281 672.878906 C 2024.488281 658.859375 2013.109375 647.480469 1999.101562 647.480469 L 1743.640625 647.480469 C 1729.628906 647.480469 1718.25 658.859375 1718.25 672.878906 C 1718.25 686.890625 1729.628906 698.269531 1743.640625 698.269531 L 1999.101562 698.269531 C 2013.109375 698.269531 2024.488281 686.890625 2024.488281 672.878906 "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(98.4375%, 84.375%, 75.78125%)",
    fillOpacity: 1,
    d: "M 1871.371094 495.609375 C 1827.410156 577.570312 1726.558594 556.519531 1752.441406 647.480469 L 1990.300781 647.480469 C 2021.089844 550.679688 1904.988281 582.28125 1871.371094 495.609375 "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(99.609375%, 89.0625%, 82.421875%)",
    fillOpacity: 1,
    d: "M 1871.371094 495.609375 C 1848.601562 569.578125 1796.371094 594.109375 1824.621094 647.480469 L 1918.121094 647.480469 C 1959.378906 583.859375 1901.359375 593.03125 1871.371094 495.609375 "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(87.889099%, 60.351562%, 43.138123%)",
    fillOpacity: 1,
    d: "M 1868.03125 479.878906 C 1855.230469 478.269531 1844.109375 468.988281 1840.800781 455.71875 C 1836.511719 438.480469 1847.019531 420.988281 1864.261719 416.699219 C 1868.921875 415.539062 1873.601562 415.460938 1878.039062 416.300781 C 1877.378906 416.410156 1876.710938 416.550781 1876.050781 416.710938 C 1862.730469 420.03125 1854.609375 433.539062 1857.929688 446.859375 C 1861.25 460.191406 1874.761719 468.308594 1888.078125 464.988281 C 1895.078125 463.238281 1900.640625 458.691406 1903.859375 452.820312 C 1901.941406 465.261719 1892.789062 475.941406 1879.820312 479.171875 C 1878.121094 479.601562 1876.410156 479.878906 1874.710938 480.019531 L 1874.710938 510.300781 L 1868.03125 510.300781 L 1868.03125 479.878906 "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(12.939453%, 15.281677%, 31.762695%)",
    fillOpacity: 1,
    d: "M 2611.058594 1232.589844 L 3040.75 1232.589844 L 3040.75 2574.371094 L 2611.058594 2574.371094 L 2611.058594 1232.589844 "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(16.088867%, 20.384216%, 37.646484%)",
    fillOpacity: 1,
    d: "M 1436.339844 1232.589844 L 2635.101562 1232.589844 L 2635.101562 2574.371094 L 1436.339844 2574.371094 L 1436.339844 1232.589844 "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(100%, 80.859375%, 31.762695%)",
    fillOpacity: 1,
    d: "M 2410.988281 1623.570312 L 2245.320312 1623.570312 L 2245.320312 1678.359375 L 2410.988281 1678.359375 Z M 2012.300781 1623.570312 L 1846.628906 1623.570312 L 1846.628906 1678.359375 L 2012.300781 1678.359375 Z M 2154.871094 1623.570312 L 2100.070312 1623.570312 L 2100.070312 1678.359375 L 2154.871094 1678.359375 Z M 1758.859375 1623.570312 L 1704.058594 1623.570312 L 1704.058594 1678.359375 L 1758.859375 1678.359375 Z M 2556.238281 1623.570312 L 2501.441406 1623.570312 L 2501.441406 1678.359375 L 2556.238281 1678.359375 Z M 1619.851562 1623.570312 L 1436.339844 1623.570312 L 1436.339844 1678.359375 L 1619.851562 1678.359375 L 1619.851562 1623.570312 "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(91.796875%, 61.131287%, 18.431091%)",
    fillOpacity: 1,
    d: "M 3041.820312 1623.570312 L 2981.660156 1623.570312 L 2981.660156 1678.359375 L 3041.820312 1678.359375 Z M 2918.609375 1623.570312 L 2863.808594 1623.570312 L 2863.808594 1678.359375 L 2918.609375 1678.359375 Z M 2800.761719 1623.570312 L 2635.089844 1623.570312 L 2635.089844 1678.359375 L 2800.761719 1678.359375 L 2800.761719 1623.570312 "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(100%, 80.859375%, 31.762695%)",
    fillOpacity: 1,
    d: "M 1436.339844 1432.839844 L 2635.101562 1432.839844 L 2635.101562 1540.761719 L 1436.339844 1540.761719 L 1436.339844 1432.839844 "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(91.796875%, 61.131287%, 18.431091%)",
    fillOpacity: 1,
    d: "M 2635.089844 1432.839844 L 3040.738281 1432.839844 L 3040.738281 1540.761719 L 2635.089844 1540.761719 L 2635.089844 1432.839844 "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(54.101562%, 35.301208%, 19.213867%)",
    fillOpacity: 1,
    d: "M 3480.621094 2588.691406 C 3480.621094 2580.410156 3473.898438 2573.691406 3465.621094 2573.691406 L 534.371094 2573.691406 C 526.09375 2573.691406 519.371094 2580.410156 519.371094 2588.691406 C 519.371094 2596.96875 526.09375 2603.691406 534.371094 2603.691406 L 3465.621094 2603.691406 C 3473.898438 2603.691406 3480.621094 2596.96875 3480.621094 2588.691406 "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(98.826599%, 74.021912%, 82.03125%)",
    fillOpacity: 1,
    d: "M 1207.03125 1520.128906 C 1207.03125 1520.128906 1217.121094 1684.230469 1184.78125 1709.78125 C 1146.671875 1739.878906 1011.859375 1738 967.007812 1817.511719 C 928.195312 1886.308594 933.113281 2575.058594 933.113281 2575.058594 L 1534.75 2575.058594 L 1536.820312 2291.53125 L 1564.660156 2575.058594 L 1749.761719 2575.058594 C 1749.761719 2575.058594 1723.660156 2519.191406 1727.070312 2516.558594 C 1705.339844 2348.460938 1638.550781 1872.089844 1572.21875 1809.441406 C 1512.5 1753.039062 1414.011719 1748.039062 1397.46875 1730.601562 C 1382.289062 1714.589844 1397.46875 1609.050781 1397.46875 1609.050781 L 1207.03125 1520.128906 "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(99.21875%, 78.90625%, 85.15625%)",
    fillOpacity: 1,
    d: "M 1635.269531 1975.988281 C 1623.269531 2046.609375 1609.25 2152.449219 1615.328125 2235.199219 C 1624.679688 2362.648438 1665.050781 2502.96875 1688.210938 2575.058594 L 1749.75 2575.058594 C 1749.75 2575.058594 1723.660156 2519.191406 1727.070312 2516.558594 C 1712.378906 2402.910156 1677.089844 2148.339844 1635.269531 1975.988281 "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(94.139099%, 54.881287%, 65.818787%)",
    fillOpacity: 1,
    d: "M 1207.128906 1521.859375 C 1207.679688 1531.921875 1210.230469 1584 1206.640625 1631.269531 C 1233.441406 1658.53125 1300.808594 1714.710938 1390.921875 1701.929688 C 1389.378906 1665.328125 1397.480469 1609.050781 1397.480469 1609.050781 L 1212.171875 1522.519531 L 1207.128906 1521.859375 "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(96.875%, 63.476562%, 74.021912%)",
    fillOpacity: 1,
    d: "M 1424.769531 1742.769531 C 1410.789062 1786.628906 1318.441406 2004.039062 1097.550781 2138.019531 C 1097.890625 2132.871094 1090.921875 2121.308594 1090.921875 2121.308594 C 1090.921875 2121.308594 1138.96875 2026.25 1136.441406 1886.210938 C 1091.378906 1910.210938 994.929688 2170.328125 936.058594 2196.230469 C 931.765625 2386.089844 933.117188 2575.058594 933.117188 2575.058594 L 1534.75 2575.058594 L 1534.75 2295.871094 L 1564.671875 2575.058594 L 1591.378906 2575.058594 L 1552.160156 2304.839844 C 1554.558594 2122.921875 1560.53125 1941.878906 1578.910156 1817.140625 C 1576.679688 1814.109375 1574.449219 1811.539062 1572.21875 1809.441406 C 1527.988281 1767.671875 1462.480469 1754.089844 1424.769531 1742.769531 "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(94.139099%, 97.264099%, 100%)",
    fillOpacity: 1,
    d: "M 1431.261719 1741.460938 C 1431.261719 1741.460938 1349.910156 2109.160156 932.914062 2233.351562 L 902.722656 2575.058594 L 1545.03125 2575.058594 L 1533.089844 2289.609375 C 1535.609375 2099.230469 1552.300781 1923.910156 1572.21875 1798.230469 C 1566.328125 1743.390625 1452.390625 1711.53125 1431.261719 1741.460938 "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(87.5%, 93.359375%, 98.4375%)",
    fillOpacity: 1,
    d: "M 1105.800781 2160.640625 L 1245.128906 2315.878906 C 1245.128906 2315.878906 1246.601562 2316.140625 1249.179688 2316.648438 C 1267.039062 2320.160156 1332.578125 2346.101562 1333.589844 2368.191406 C 1334.609375 2390.609375 1295.238281 2394.078125 1295.238281 2394.078125 C 1295.238281 2394.078125 1332.609375 2432.421875 1333.589844 2453.230469 C 1336.269531 2510.160156 1192.878906 2561.308594 1173.910156 2555.871094 C 1138.089844 2545.589844 1097.78125 2473.839844 1097.78125 2473.839844 C 1097.78125 2473.839844 1007.601562 2436.230469 923.175781 2356.328125 L 932.90625 2233.351562 C 994.75 2214.941406 1057.859375 2187.789062 1105.800781 2160.640625 "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(87.5%, 93.359375%, 98.4375%)",
    fillOpacity: 1,
    d: "M 1568.058594 1783.828125 C 1550.71875 1861.179688 1482.621094 2158.351562 1431.261719 2289.609375 C 1388.191406 2399.679688 1314.28125 2511.019531 1268.148438 2575.050781 L 1545.03125 2575.050781 L 1533.089844 2289.609375 C 1535.601562 2099.230469 1552.289062 1923.910156 1572.210938 1798.230469 C 1571.679688 1793.21875 1570.238281 1788.410156 1568.058594 1783.828125 "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(71.679688%, 81.25%, 89.451599%)",
    fillOpacity: 1,
    d: "M 1321.148438 2191.398438 C 1321.148438 2191.398438 1334.929688 2177.859375 1355.578125 2153.121094 C 1368.980469 2137.070312 1385.300781 2116.390625 1402.488281 2091.589844 C 1411.71875 2078.289062 1421.179688 2063.800781 1430.558594 2048.230469 C 1436.320312 2038.660156 1442.058594 2028.691406 1447.628906 2018.300781 C 1452.941406 2008.390625 1458.101562 1998.101562 1463.101562 1987.5 C 1470.269531 1972.289062 1477.089844 1956.429688 1483.460938 1940 C 1489.578125 1924.230469 1495.261719 1907.949219 1500.371094 1891.210938 C 1507.75 1867.03125 1513.890625 1841.941406 1518.550781 1816.121094 C 1512.328125 1841.511719 1504.550781 1866.050781 1495.839844 1889.691406 C 1489.839844 1905.980469 1483.378906 1921.808594 1476.621094 1937.160156 C 1469.578125 1953.128906 1462.191406 1968.53125 1454.671875 1983.371094 C 1449.429688 1993.71875 1444.109375 2003.78125 1438.828125 2013.558594 C 1433.289062 2023.828125 1427.800781 2033.800781 1422.320312 2043.398438 C 1413.390625 2059.050781 1404.539062 2073.71875 1396 2087.308594 C 1380.039062 2112.710938 1365.171875 2134.238281 1352.859375 2150.980469 C 1333.820312 2176.890625 1321.148438 2191.398438 1321.148438 2191.398438 Z M 926.839844 2302.039062 L 926.660156 2304.101562 C 939.660156 2302.058594 957.457031 2298.730469 978.808594 2293.351562 C 1009.480469 2285.628906 1047.441406 2273.839844 1088.890625 2255.511719 C 1111.210938 2245.648438 1134.5 2233.859375 1158.148438 2219.828125 C 1172.609375 2211.25 1187.210938 2201.828125 1201.71875 2191.398438 C 1215.429688 2181.539062 1229.058594 2170.769531 1242.53125 2159.121094 C 1261.511719 2142.71875 1280.140625 2124.570312 1298.191406 2104.589844 C 1315.011719 2085.988281 1331.261719 2065.808594 1346.730469 2043.890625 C 1367.960938 2013.789062 1387.578125 1980.5 1405.21875 1943.730469 C 1385.171875 1978.960938 1363.230469 2010.488281 1340.238281 2039 C 1323.660156 2059.558594 1306.53125 2078.449219 1289.058594 2095.910156 C 1270.421875 2114.550781 1251.371094 2131.429688 1232.289062 2146.890625 C 1218.78125 2157.828125 1205.230469 2168.011719 1191.820312 2177.601562 C 1177.621094 2187.75 1163.570312 2197.21875 1149.671875 2205.980469 C 1126.878906 2220.339844 1104.578125 2232.78125 1083.238281 2243.558594 C 1043.308594 2263.710938 1006.839844 2277.980469 977.171875 2287.699219 C 956.695312 2294.398438 939.519531 2299.011719 926.839844 2302.039062 Z M 910.816406 2483.410156 L 910.289062 2489.378906 C 912.6875 2488.511719 915.160156 2487.609375 917.710938 2486.660156 C 939.441406 2478.640625 966.429688 2468.199219 996.039062 2455.089844 C 1012.410156 2447.839844 1029.53125 2439.78125 1046.96875 2430.898438 C 1057.960938 2425.308594 1069.070312 2419.410156 1080.121094 2413.101562 C 1090.921875 2406.929688 1101.660156 2400.359375 1112.300781 2393.53125 C 1128.128906 2383.359375 1143.679688 2372.570312 1158.738281 2361.300781 C 1174.019531 2349.871094 1188.71875 2337.949219 1202.550781 2325.601562 C 1224.53125 2305.960938 1244.160156 2285.328125 1260.410156 2264.070312 C 1240.441406 2285.570312 1216.25 2305.660156 1189.921875 2324.808594 C 1165.339844 2342.699219 1138.871094 2359.488281 1111.988281 2375.25 C 1102.339844 2380.910156 1092.660156 2386.449219 1083.03125 2391.921875 C 1076.53125 2395.609375 1070.058594 2399.269531 1063.648438 2402.921875 C 1047.03125 2412.378906 1030.660156 2421.429688 1014.878906 2429.988281 C 993.761719 2441.429688 973.75 2451.980469 955.527344 2461.269531 C 938.859375 2469.761719 923.738281 2477.199219 910.816406 2483.410156 Z M 1304.230469 2575.058594 L 1309.691406 2575.058594 C 1319.96875 2565.488281 1332.128906 2553.78125 1345.269531 2540.109375 C 1353.449219 2531.609375 1361.980469 2522.351562 1370.671875 2512.390625 C 1376.019531 2506.261719 1381.441406 2499.871094 1386.800781 2493.179688 C 1391.929688 2486.789062 1397.011719 2480.128906 1402.058594 2473.269531 C 1409.339844 2463.378906 1416.511719 2453.050781 1423.539062 2442.378906 C 1430.359375 2432.039062 1437 2421.390625 1443.398438 2410.441406 C 1452.808594 2394.359375 1461.628906 2377.710938 1469.75 2360.679688 C 1459.191406 2378.730469 1447.648438 2396.128906 1435.808594 2412.96875 C 1423.601562 2430.328125 1411 2446.949219 1398.488281 2462.710938 C 1393.78125 2468.628906 1389.089844 2474.441406 1384.488281 2480.148438 C 1381.320312 2484.058594 1378.199219 2487.929688 1375.121094 2491.75 C 1366.988281 2501.851562 1359.089844 2511.5 1351.5 2520.609375 C 1341.089844 2533.109375 1331.320312 2544.570312 1322.429688 2554.710938 C 1315.808594 2562.261719 1309.699219 2569.070312 1304.230469 2575.058594 Z M 1068.011719 2575.058594 L 1071.519531 2575.058594 C 1090.820312 2561.039062 1120.089844 2539.28125 1154.601562 2511.960938 C 1176.128906 2494.921875 1199.679688 2475.738281 1224.011719 2454.808594 C 1242.359375 2439.03125 1261.140625 2422.269531 1279.851562 2404.761719 C 1287.109375 2397.960938 1294.328125 2391.019531 1301.480469 2383.96875 C 1312.140625 2373.46875 1322.671875 2362.730469 1333.011719 2351.820312 C 1362.261719 2321 1390.199219 2289.070312 1414.890625 2257.261719 C 1442.570312 2221.578125 1465.980469 2186.03125 1482.761719 2152.511719 C 1463.988281 2184.730469 1438.238281 2218.320312 1408.789062 2252.261719 C 1382.601562 2282.441406 1353.398438 2312.738281 1323.28125 2342.25 C 1312.621094 2352.691406 1301.871094 2363.050781 1291.140625 2373.320312 C 1283.929688 2380.21875 1276.730469 2387.078125 1269.578125 2393.898438 C 1251.148438 2411.5 1232.890625 2428.609375 1215.210938 2444.941406 C 1191.730469 2466.628906 1169.320312 2486.949219 1148.871094 2505.128906 C 1114.738281 2535.46875 1086.171875 2559.808594 1068.011719 2575.058594 "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(100%, 80.076599%, 86.326599%)",
    fillOpacity: 1,
    d: "M 1134.898438 1918.21875 C 1124.121094 2006.671875 1068.429688 2131.289062 1068.429688 2131.289062 L 1239.808594 2326.519531 C 1239.808594 2326.519531 1321.648438 2346.570312 1322.800781 2371.839844 C 1323.828125 2394.269531 1274.949219 2388.089844 1274.949219 2388.089844 C 1274.949219 2388.089844 1315.710938 2420.71875 1316.691406 2441.539062 C 1319.378906 2498.460938 1197.429688 2537.910156 1178.460938 2532.46875 C 1142.640625 2522.199219 1114.589844 2458.890625 1114.589844 2458.890625 C 1114.589844 2458.890625 838.5 2287.269531 821.222656 2158.578125 C 805.421875 2040.890625 900.179688 1856.851562 952.347656 1815.660156 C 1035.988281 1749.609375 1148.011719 1810.71875 1134.898438 1918.21875 "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(99.609375%, 72.459412%, 81.25%)",
    fillOpacity: 1,
    d: "M 830.257812 2050.070312 C 837.714844 2096.289062 850.433594 2152.28125 870.753906 2180.378906 C 908.921875 2233.171875 1130.628906 2435.390625 1130.628906 2435.390625 C 1130.628906 2435.390625 1169.660156 2505.859375 1207.25 2528.878906 C 1193.75 2532.46875 1183.070312 2533.800781 1178.460938 2532.46875 C 1142.640625 2522.199219 1114.589844 2458.890625 1114.589844 2458.890625 C 1114.589844 2458.890625 838.5 2287.269531 821.222656 2158.578125 C 816.851562 2126.011719 820.945312 2088.371094 830.257812 2050.070312 "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(31.37207%, 15.696716%, 7.446289%)",
    fillOpacity: 1,
    d: "M 1525.578125 1306.25 C 1525.578125 1306.25 1508.121094 1415.691406 1464.460938 1441.890625 L 1464.460938 1325.179688 L 1525.578125 1306.25 "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(98.826599%, 74.021912%, 82.03125%)",
    fillOpacity: 1,
    d: "M 1220.398438 1470.359375 C 1216.78125 1437.800781 1173 1416.910156 1147.109375 1447.71875 C 1118.679688 1481.550781 1165.210938 1535.449219 1202.121094 1516.101562 C 1202.121094 1516.101562 1210.050781 1582.828125 1268.199219 1610.871094 C 1333.519531 1642.359375 1426.960938 1627.429688 1452.488281 1588.398438 C 1476.558594 1551.601562 1487.199219 1399.730469 1452.488281 1325.171875 L 1227.441406 1325.171875 L 1220.398438 1470.359375 "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(94.139099%, 59.568787%, 70.506287%)",
    fillOpacity: 1,
    d: "M 1282.28125 1616.800781 L 1412.78125 1616.800781 C 1430.53125 1610.011719 1444.679688 1600.328125 1452.488281 1588.398438 C 1462.371094 1573.300781 1469.988281 1538.800781 1473.128906 1498.21875 C 1457.621094 1490.769531 1431.808594 1482.238281 1408.839844 1492.769531 C 1408.839844 1492.769531 1379.039062 1481.738281 1355.789062 1492.769531 C 1332.539062 1503.789062 1312.871094 1513.929688 1299.75 1506.179688 C 1286.640625 1498.429688 1270.25 1476.53125 1270.25 1476.53125 C 1270.25 1476.53125 1291.109375 1403.351562 1287.53125 1383.980469 C 1287.53125 1383.980469 1360.558594 1379.800781 1389.171875 1360.730469 C 1414.828125 1343.621094 1448.648438 1357.921875 1466.101562 1367.5 C 1462.699219 1351.859375 1458.210938 1337.46875 1452.488281 1325.171875 L 1227.441406 1325.171875 L 1220.398438 1470.359375 C 1216.78125 1437.800781 1173 1416.910156 1147.109375 1447.71875 C 1118.671875 1481.550781 1165.210938 1535.449219 1202.109375 1516.101562 C 1202.109375 1516.101562 1210.050781 1582.828125 1268.199219 1610.871094 C 1272.761719 1613.070312 1277.46875 1615.039062 1282.28125 1616.800781 "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(48.242188%, 25.097656%, 13.330078%)",
    fillOpacity: 1,
    d: "M 1255.910156 1482.160156 C 1255.910156 1482.160156 1277.21875 1412.441406 1270.558594 1368.019531 C 1270.558594 1368.019531 1325.210938 1375.570312 1361.640625 1358.238281 C 1398.070312 1340.910156 1411.390625 1336.921875 1438.488281 1347.578125 C 1455.539062 1354.289062 1524.679688 1370.101562 1541.949219 1310.570312 C 1554.621094 1266.890625 1548.308594 1242.820312 1509.050781 1231.429688 C 1521.320312 1189.128906 1510.140625 1111.460938 1403.261719 1129.390625 C 1394.339844 1076.101562 1230.269531 1038.679688 1204.03125 1162.710938 C 1167.800781 1155.039062 1083.128906 1209.828125 1124.199219 1310.570312 C 1100.148438 1328.921875 1073.53125 1412.828125 1138.320312 1466.878906 C 1147.949219 1427.828125 1196.140625 1415.03125 1222.089844 1466.878906 L 1255.910156 1482.160156 "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(58.006287%, 34.910583%, 14.892578%)",
    fillOpacity: 1,
    d: "M 1099.960938 1358.761719 C 1108.351562 1341.648438 1122.46875 1320.558594 1141.890625 1317.921875 C 1123.109375 1288.421875 1121.488281 1186.75 1207.460938 1173.71875 C 1237.839844 1097.53125 1337.589844 1062.808594 1396.550781 1146.199219 C 1429.730469 1130.769531 1510.121094 1153.410156 1496.460938 1232.800781 C 1496.460938 1232.800781 1531.71875 1246.101562 1547.539062 1270.078125 C 1545.558594 1250.941406 1533.910156 1238.640625 1509.050781 1231.429688 C 1521.320312 1189.128906 1510.140625 1111.460938 1403.261719 1129.390625 C 1394.339844 1076.101562 1230.269531 1038.679688 1204.03125 1162.710938 C 1167.789062 1155.039062 1083.128906 1209.828125 1124.199219 1310.570312 C 1114.460938 1318 1104.300781 1336.171875 1099.960938 1358.761719 "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(42.358398%, 21.556091%, 11.767578%)",
    fillOpacity: 1,
    d: "M 1544.230469 1302.089844 C 1543.558594 1304.828125 1542.800781 1307.648438 1541.949219 1310.558594 C 1524.679688 1370.101562 1455.539062 1354.28125 1438.5 1347.578125 C 1411.398438 1336.910156 1398.070312 1340.910156 1361.640625 1358.238281 C 1325.210938 1375.570312 1270.558594 1368.011719 1270.558594 1368.011719 C 1277.230469 1412.441406 1255.910156 1482.160156 1255.910156 1482.160156 L 1222.101562 1466.878906 C 1196.140625 1415.03125 1147.949219 1427.828125 1138.328125 1466.878906 C 1117.679688 1449.648438 1106.308594 1429.390625 1101.191406 1409.179688 C 1118.171875 1402.238281 1144.640625 1394.140625 1169.339844 1397.921875 C 1197.769531 1402.269531 1222.199219 1416.320312 1242.558594 1427.441406 C 1242.558594 1427.441406 1248.800781 1366.730469 1242.558594 1339.710938 C 1242.558594 1339.710938 1331.128906 1369.25 1364.808594 1329.308594 C 1388.949219 1300.691406 1437.070312 1328.03125 1472.089844 1335.960938 C 1504.589844 1343.328125 1528.789062 1326.511719 1544.230469 1302.089844 "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(48.242188%, 25.097656%, 13.330078%)",
    fillOpacity: 1,
    d: "M 1256.671875 1482.160156 C 1256.671875 1482.160156 1267.589844 1518.320312 1302.25 1521.859375 C 1336.910156 1525.398438 1348.308594 1491.078125 1410.988281 1503.289062 C 1444.570312 1497.679688 1465.640625 1500.21875 1481.820312 1518.230469 C 1509.128906 1548.648438 1469.628906 1618.648438 1448.769531 1637.371094 C 1431.050781 1653.289062 1355.21875 1674.070312 1306.519531 1664.691406 C 1251.199219 1654.039062 1198.289062 1618.480469 1194.398438 1519.070312 C 1194.398438 1519.070312 1226.261719 1511.53125 1222.339844 1466.878906 L 1256.671875 1482.160156 "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(94.139099%, 59.568787%, 70.506287%)",
    fillOpacity: 1,
    d: "M 1363.878906 1568.320312 C 1363.878906 1568.320312 1390.789062 1560.398438 1410.179688 1560.519531 C 1422.96875 1560.609375 1432.191406 1562.96875 1444.011719 1564.289062 C 1432.28125 1594.078125 1382.570312 1599.011719 1363.878906 1568.320312 "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(42.358398%, 21.556091%, 11.767578%)",
    fillOpacity: 1,
    d: "M 1222.238281 1482.199219 L 1222.339844 1482.160156 C 1222.339844 1482.160156 1222.269531 1482.449219 1222.140625 1483 C 1222.171875 1482.730469 1222.210938 1482.46875 1222.238281 1482.199219 Z M 1222.339844 1466.890625 L 1256.671875 1482.160156 C 1256.671875 1482.160156 1267.589844 1518.320312 1302.25 1521.859375 C 1336.921875 1525.398438 1348.320312 1491.078125 1410.988281 1503.289062 C 1444.570312 1497.679688 1465.648438 1500.21875 1481.820312 1518.230469 C 1488.238281 1525.390625 1490.96875 1534.730469 1491.109375 1545.078125 C 1476.019531 1508.640625 1428.371094 1504.089844 1411.769531 1510.339844 C 1368.660156 1499.230469 1320.078125 1550.5 1287.21875 1543.328125 C 1244.179688 1533.949219 1222.339844 1466.890625 1222.339844 1466.890625 Z M 1219.660156 1493.789062 C 1216.609375 1507.378906 1212.078125 1528.898438 1212.261719 1535.808594 C 1212.519531 1546.058594 1257.160156 1645.46875 1351.738281 1666.261719 C 1335.800781 1667.578125 1320.101562 1667.308594 1306.519531 1664.699219 C 1251.199219 1654.039062 1198.289062 1618.480469 1194.410156 1519.078125 C 1194.410156 1519.078125 1212.378906 1514.820312 1219.660156 1493.789062 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHajIlustrations2);
export default __webpack_public_path__ + "static/media/Haj_Ilustrations_2.82ee2e19f39ea84b29658253118fa065.svg";
export { ForwardRef as ReactComponent };